import React, { useState } from 'react';
import { change, FieldArray } from 'redux-form';
import { faMinusCircle, faPlusCircle, faRedo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import styles from './assets/program-array-fields.module.scss';
import { FieldInput } from '../../../../../components/redux-form/fields/FieldInput';
import { FieldDropdown } from '../../../../../components/redux-form/fields/FieldDropdown';
import { getValFromEnum } from '../../../../../components/redux-form/utils/dropdown-values';
import GeneralEnumService from '../../../../../enumerables/general-enum';
import RenderPhaseStepsArray from './RenderPhaseStepsArray';
import RenderPromptsArray from './RenderPromptsArray';
import { FieldDate } from '../../../../../components/redux-form/fields/FieldDate';

const RenderFieldArray = (props: any) => {
    const {
        fields,
        showAttempts,
        showPrompt,
        masteryDirectionItems,
        showOption,
        isPromts,
        typeLabel,
        handleChange,
        validators,
    } = props;

    return (
        <ul className={classNames(styles.ul, styles.targetWrap, styles.optionsWrap, styles.phasesWrap)}>
            {fields.length === 0 ? (
                <li className={classNames(styles.addBtnLi)}>
                    <button
                        type="button"
                        className={classNames('btn', 'btn-outline-info', 'mr-3', styles.addBtn)}
                        onClick={() => fields.push({})}
                    >
                        <FontAwesomeIcon icon={faPlusCircle} /> <span>Add phase</span>
                    </button>
                </li>
            ) : null}
            {fields.map((member: any, index: number, array: any) => (
                <RenderSubFields
                    key={`i-${index}`}
                    member={member}
                    fields={array}
                    isLast={index + 1 === fields.length}
                    isNotFirst={!!index}
                    index={index}
                    showAttempts={showAttempts}
                    showPrompt={showPrompt}
                    typeLabel={typeLabel}
                    masteryDirectionItems={masteryDirectionItems}
                    showOption={showOption}
                    handleChange={handleChange}
                    isPromts={isPromts}
                    validators={validators}
                />
            ))}
        </ul>
    );
};
type Props = {
    member: any;
    index: number;
    fields: any;
    isLast: boolean;
    isNotFirst: boolean;
    showAttempts: any;
    showPrompt: any;
    masteryDirectionItems: any;
    showOption: any;
    isPromts: any;
    typeLabel: any;
    handleChange: any;
    validators: any;
};

const RenderSubFields: React.FunctionComponent<Props> = ({
    member,
    index,
    fields,
    isLast,
    isNotFirst,
    showAttempts,
    showPrompt,
    masteryDirectionItems,
    showOption,
    typeLabel,
    handleChange,
    isPromts,
    validators,
}) => {
    const dispatch = useDispatch();
    const [changeSt, setChanged] = useState(false);
    const row = fields.get(index);

    const completePhase = () => {
        dispatch(change('program-book', `${member}.isComplete`, 1));
        /*setTimeout(() => {
            setChanged(!changeSt);
        }, 200);*/
    };

    const deleteRow = () => {
        if (!row.id) {
            fields.remove(index);
            setTimeout(() => {
                setChanged(!changeSt);
            }, 200);
        } else {
            dispatch(change('program-book', `${member}.status`, 2));
            setTimeout(() => {
                setChanged(!changeSt);
            }, 200);
        }
    };

    const backRow = () => {
        dispatch(change('program-book', `${member}.status`, 1));
        setTimeout(() => {
            setChanged(!changeSt);
        }, 200);
    };
    const creditStyle = {
        display: 'none',
    };

    const EnumSet = GeneralEnumService ? GeneralEnumService.getEnum('ProgramPrompt') : {};
    const promptItems: SelectObject[] = getValFromEnum(EnumSet);

    if (!row.prompt) {
        row.prompt = 10;
    }

    let isMasteredLabel = '';
    if (row.isMastered) {
        isMasteredLabel = ' (mastered)';
    }

    const isApplied: boolean = +row.status === 3;
    return (
        <li
            style={+row.status === 2 ? creditStyle : {}}
            className={classNames('w-100', styles.phaseBlock, +row.isComplete == 1 ? styles.phaseCoverBlock : '')}
            key={index}
        >
            <div className={classNames(styles.phaseCover)}></div>
            <div className={classNames(styles.wrappedFields, styles.wrappedBaseline)}>
                <FieldInput
                    name={`${member}.id`}
                    type="hidden"
                    wrapperConfig={{
                        classes: {
                            inputWrapper: 'm-0',
                        },
                    }}
                />
                <FieldInput
                    name={`${member}.isComplete`}
                    type="hidden"
                    wrapperConfig={{
                        classes: {
                            inputWrapper: 'm-0',
                        },
                    }}
                />
                <FieldInput
                    name={`${member}.endDate`}
                    type="hidden"
                    wrapperConfig={{
                        classes: {
                            inputWrapper: 'm-0',
                        },
                    }}
                />

                <div className={classNames(styles.wrappedFields, styles.wrappedBaseline, styles.wrappedBaselineDirection)}>
                    <div className={classNames(styles.wrappedFields, styles.wrappedBaseline)}>
                        <FieldInput
                            name={`${member}.title`}
                            type="text"
                            validate={validators.phaseTitle}
                            wrapperConfig={{
                                label: 'Phase title' + isMasteredLabel + ' *: ',
                                classes: { inputWrapper: 'mr-3 w-50 ' + classNames(styles.wFullWidth) },
                            }}
                        />
                        <FieldDate
                            name={`${member}.startDate`}
                            type="text"
                            date={true}
                            validate={validators.phaseStartDate}
                            wrapperConfig={{
                                label: 'Phase start date *: ',
                                classes: { inputWrapper: 'mr-3 w-50 ' + classNames(styles.wFullWidth) },
                            }}
                        />
                    </div>
                    <div className={classNames(styles.wrappedFields, styles.wrappedBaseline)}>
                        {showAttempts ? (
                            <FieldInput
                                name={`${member}.minAttempts`}
                                type="number"
                                wrapperConfig={{
                                    label: 'Attempts:',
                                    classes: { inputWrapper: 'mr-3 w-50 ' + classNames(styles.wFullWidth) },
                                }}
                            />
                        ) : null}
                        {showPrompt ? (
                            <FieldDropdown
                                name={`${member}.prompt`}
                                data={promptItems}
                                //onChange={() => memberD.push({})}
                                textField={'label'}
                                valueField={'value'}
                                wrapperConfig={{
                                    label: 'Prompt:',
                                    classes: { inputWrapper: 'mr-3 w-33 mb-0 ' + classNames(styles.wFullWidth) },
                                }}
                            />
                        ) : null}

                        <FieldInput
                            name={`${member}.masterValue`}
                            type="number"
                            wrapperConfig={{
                                label: 'Mastery' + typeLabel + ' *:',
                                classes: { inputWrapper: 'mr-3 w-33 ' + classNames(styles.wFullWidth) },
                            }}
                        />
                        <FieldDropdown
                            name={`${member}.masteryDirection`}
                            data={masteryDirectionItems}
                            textField={'label'}
                            valueField={'value'}
                            wrapperConfig={{
                                label: 'Mastery direction *:',
                                classes: { inputWrapper: 'mr-3 w-33 mb-0 ' + classNames(styles.wFullWidth) },
                            }}
                        />
                        <FieldInput
                            name={`${member}.masterNumberOfSeance`}
                            type="number"
                            wrapperConfig={{
                                label: 'During sessions *:',
                                classes: { inputWrapper: 'mr-3 w-33 ' + classNames(styles.wFullWidth) },
                            }}
                        />
                    </div>

                    {showOption ? (
                        <div className={classNames(styles.wrappedFields, styles.wrappedBaseline)}>
                            <FieldArray name={`${member}.programTargetPhaseOptions`} component={RenderPhaseStepsArray} />
                        </div>
                    ) : null}

                    <div className={classNames(styles.hidden)}>
                        <ul
                            className={classNames(styles.ul, styles.targetWrap, styles.propsNeedWrap)}
                            style={{ paddingBottom: 0 }}
                        >
                            <li>
                                <FieldInput
                                    name={`${member}.hasPrompts`}
                                    type="checkbox"
                                    onChange={handleChange}
                                    wrapperConfig={{
                                        label: 'Need prompts?',
                                        classes: {
                                            inputWrapper: 'customCheckbox',
                                        },
                                    }}
                                />
                            </li>
                        </ul>
                        {isPromts ? (
                            <FieldArray name={`${member}.programTargetPrompts`} component={RenderPromptsArray} />
                        ) : null}
                    </div>
                </div>
            </div>
            {isLast && row.id ? (
                <button
                    type="button"
                    className={classNames('btn', 'btn-outline-info', ' mt-2 ', styles.addBtn, styles.completeBtn)}
                    onClick={() => {
                        completePhase();
                        fields.push({});
                    }}
                >
                    <FontAwesomeIcon icon={faPlusCircle} /> <span>Complete the phase and create new one</span>
                </button>
            ) : null}
        </li>
    );
};
export default RenderFieldArray;
